// src/components/DuplicatePlayersModal.jsx
// Fenêtre d'alerte "joueurs similaires" : tableau de tous les doublons potentiels
import React from 'react';
import { refs } from '../data/refs';

const classementLabel = (code) => {
  if (!code) return '';
  const f = refs.refClassement.find(c => c.code === String(code).trim());
  return f ? f.labelFr : code;
};

/**
 * Props :
 *  - candidates : joueurs similaires trouvés
 *  - searched   : { nom, prenom } saisis par l'utilisateur
 *  - onUse(player) : utiliser un joueur existant
 *  - onCreateNew() : créer quand même un nouveau joueur
 *  - onCancel() : fermer sans rien faire (retour au formulaire)
 */
export default function DuplicatePlayersModal({ candidates, searched, onUse, onCreateNew, onCancel }) {
  const th = { textAlign: 'left', padding: '6px 8px', fontSize: '12px', color: '#666', borderBottom: '2px solid #ddd', whiteSpace: 'nowrap' };
  const td = { padding: '8px', fontSize: '13px', borderBottom: '1px solid #eee', verticalAlign: 'middle' };

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '12px',
    }}>
      <div style={{
        backgroundColor: '#fff', color: '#222', borderRadius: '12px', padding: '16px',
        width: '100%', maxWidth: '560px', maxHeight: '90vh', overflowY: 'auto',
        boxShadow: '0 8px 30px rgba(0,0,0,0.3)', fontFamily: 'Arial, sans-serif',
      }}>
        <h3 style={{ margin: '0 0 6px', fontSize: '17px' }}>⚠️ Joueur déjà existant ?</h3>
        <p style={{ margin: '0 0 12px', fontSize: '13px', color: '#555' }}>
          Vous saisissez <strong>{[searched?.prenom, searched?.nom].filter(Boolean).join(' ')}</strong>.
          {' '}{candidates.length > 1 ? `${candidates.length} joueurs similaires existent déjà` : 'Un joueur similaire existe déjà'} :
        </p>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={th}>Joueur</th>
                <th style={th}>Class.</th>
                <th style={th}>Club</th>
                <th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {candidates.map(c => (
                <tr key={c.id}>
                  <td style={td}><strong>{[c.prenom, c.nom].filter(Boolean).join(' ')}</strong></td>
                  <td style={td}>{classementLabel(c.dernierClassementCode)}</td>
                  <td style={td}>{c.dernierClub || ''}</td>
                  <td style={{ ...td, textAlign: 'right' }}>
                    <button
                      type="button"
                      onClick={() => onUse(c)}
                      style={{
                        padding: '6px 12px', borderRadius: '6px', border: 'none',
                        backgroundColor: '#1976D2', color: '#fff', fontSize: '13px',
                        fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
                      }}
                    >
                      Utiliser
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <button
          type="button"
          onClick={onCreateNew}
          style={{
            width: '100%', marginTop: '14px', padding: '10px', borderRadius: '8px',
            border: '1px solid #bbb', backgroundColor: '#f5f5f5', color: '#333',
            fontSize: '14px', cursor: 'pointer',
          }}
        >
          Aucun ne correspond : créer un nouveau joueur
        </button>

        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            style={{
              width: '100%', marginTop: '8px', padding: '10px', borderRadius: '8px',
              border: 'none', backgroundColor: 'transparent', color: '#1976D2',
              fontSize: '14px', cursor: 'pointer',
            }}
          >
            Je ne suis pas sûr : annuler et revenir au formulaire
          </button>
        )}
      </div>
    </div>
  );
}